import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { PageHeader, Form, FormGroup, Row, Col, FormControl, Button, ControlLabel, HelpBlock } from 'react-bootstrap';
import Logo from '../core/components/Logo'
import {Link} from 'react-router-dom';
import ToggleSwitch from '../core/components/ToggleSwitch'
import { axiosInstance } from '../utils/ApiHelper';

class PasswordResetsContainer extends React.Component {
  constructor(){
    super()

    this.state = {
      password: "",
      password_confirmation: "",
      isFetching: false,
      formErrorMessage: '',
      success: false,
      title: "Choose New Password",
      touched:false
    }
  }


  getValidationState(fieldName) {
    const length = this.state[fieldName].length;
    if (length > 6) return 'success';
    else if (length > 0) return 'error';
    return null;
  }

  componentDidMount(){

  }

  handleOnSubmit(event){

    event.preventDefault()

    // Set fetching state
    this.setState(Object.assign({}, this.state, {
        isFetching: true
    }))

    const { params } = this.props
    let url = 'password_resets/' + params.id
    var data = {}
    data["password"] = this.state.password
    data["password_confirmation"] = this.state.password_confirmation

    // Update email subscriptions with server
    axiosInstance.put(url,data).then(response => {
      if (response.status != 201) {
        // Error
        this.setState(Object.assign({}, this.state, {
          formErrorMessage: response.data.error_message,
          isFetching: false,
          title: "Hmm something went wrong. This reset link might be expired. Please try requesting a new password reset or contact support@everlance.com"

        }))
      } else {
        // Success
        this.setState(Object.assign({}, this.state, {
          success: true,
          isFetching: false,
          title: "Sweet! Now try to log in.",
          password: "",
          password_confirmation: ""
        }))
      }
    })
  }

  handleChange(e) {
    this.setState({touched:true})
    var stateChange = {}
    stateChange[e.target.name] = e.target.value
    this.setState(Object.assign({}, this.state, stateChange))
  }

  render() {

    const errorsBox = {
        width: "100% ",
        textAlign: "center",
        color: "#d02f2f",
        marginTop: "15px"
    }

    return (
      <div className="password-resets-container">
        <div className="">
          <Form className="credentials-form" onSubmit={!this.state.isFetching ? this.handleOnSubmit.bind(this) : null} horizontal>
            <Logo />

            <FormGroup controlId="formTitle">
             <Col sm={12}>
               <h3 className="form-title">{this.state.title}</h3>
             </Col>
            </FormGroup>

            {!this.state.success && (
              <div>
                <FormGroup
                  validationState={this.getValidationState('password')}
                  controlId="formHorizontalEmail">
                 <Col sm={12}>
                   <FormControl className="input-lg" type="password" name="password" value={this.state.password} placeholder="New Password" onChange={this.handleChange.bind(this)} />
                   <FormControl.Feedback />
                 </Col>

                </FormGroup>
                <FormGroup
                  validationState={this.getValidationState('password_confirmation')}
                  controlId="formHorizontalEmail">
                 <Col sm={12}>
                   <FormControl className="input-lg" type="password" name="password_confirmation" value={this.state.password_confirmation} placeholder="New Password Confirmation" onChange={this.handleChange.bind(this)} />
                   <FormControl.Feedback />

                 </Col>
                </FormGroup>

                <FormGroup>
                 <Col sm={12}>
                   {  this.state.touched &&
                     (this.state.password.length<6 || this.state.password_confirmation.length<6) &&
                     <code>Password length must be at least 6 characters</code>
                   }
                   <Button disabled={this.state.isFetching|| this.state.password.length<6 || this.state.password_confirmation.length<6} className="btn-main-green" bsSize="large" type="submit" >
                    {this.state.isFetching ? "Saving..." : "Save"}
                   </Button>

                   <div style={errorsBox}>
                     {this.state.formErrorMessage}
                   </div>
                 </Col>
               </FormGroup>
              </div>
            )}
            {this.state.success && (
              <FormGroup>
               <Col sm={12}>
                <Link to="/login">
                 <Button className="btn-main-green" bsSize="large" type="submit" >
                    Go To Login
                 </Button>
                </Link>
               </Col>
             </FormGroup>
            )}

          </Form>
        </div>
      </div>

    )
  }
}

PasswordResetsContainer.propTypes = {
};

export default connect()(PasswordResetsContainer)



// WEBPACK FOOTER //
// ./src/user/PasswordResetsEditContainer.js